import UnderConstruction from './under-construction';
export default UnderConstruction;
